module.exports = __webpack_public_path__ + "static/media/advenio.663fb86e.svg";